/**
 * @generated SignedSource<<93f03581ca32a31ac0219885c126b7f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DownloadPQiSummaryOrQualityReportButton_survey$data = {
  readonly projectRawId: string;
  readonly resultsUnlocked: boolean;
  readonly surveyNumber: number;
  readonly " $fragmentSpreads": FragmentRefs<"ApproveDownloadDialog_survey">;
  readonly " $fragmentType": "DownloadPQiSummaryOrQualityReportButton_survey";
};
export type DownloadPQiSummaryOrQualityReportButton_survey$key = {
  readonly " $data"?: DownloadPQiSummaryOrQualityReportButton_survey$data;
  readonly " $fragmentSpreads": FragmentRefs<"DownloadPQiSummaryOrQualityReportButton_survey">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DownloadPQiSummaryOrQualityReportButton_survey",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectRawId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "surveyNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resultsUnlocked",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApproveDownloadDialog_survey"
    }
  ],
  "type": "ProjectSurvey",
  "abstractKey": null
};

(node as any).hash = "b0b1185789408a33ef3ce5347a43a9aa";

export default node;
